import React from 'react';
import { Grid } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';

import { pad02 } from '../../constants';

class ChatItem extends React.Component {
  // eslint-disable-next-line
  constructor(props) {
    super(props);
  }

  render() {
    const convertT = () => {
      let date = new Date(Number(this.props.chatData.createdAt));
      return pad02(date.getHours()) + ':' + pad02(date.getMinutes());
    };

    return (
      <div style={{ marginBottom: '20px' }}>
        {this.props.chatData.userid === sessionStorage.getItem('_in_user_') ? (
          <div>
            <Grid container justify={'flex-end'} alignItems={'center'}>
              {/* <Avatar alt="Remy Sharp" src="https://material-ui.com/static/images/avatar/1.jpg" /> */}
              <div style={{ /*marginLeft: '10px',*/ fontWeight: 'bold', marginRight: '10px' }}>
                {!this.props.chatData.usernameEn || this.props.chatData.usernameEn === '' || this.props.chatData.usernameEn === 'undefined'
                  ? this.props.chatData.username
                  : this.props.chatData.usernameEn}
              </div>
            </Grid>
            <Grid
              container
              direction={'row'}
              justify={'flex-end'}
              style={
                {
                  /*paddingLeft: '40px'*/
                }
              }
              alignItems={'flex-end'}
            >
              <div style={{ fontSize: '0.8rem', paddingLeft: '10px', marginRight: '10px' }}>{convertT(this.props.chatData.createdAt)}</div>
              <Paper
                style={{
                  padding: '10px 15px',
                  backgroundColor: '#f3e5fa',
                  maxWidth: '80%',
                  marginRight: '10px',
                  wordBreak: 'break-word',
                  wordWrap: 'break-word',
                  whiteSpace: 'pre-line',
                  // fontSize: '3rem',
                  fontSize: '9rem',
                }}
              >
                {this.props.chatData.data}
              </Paper>
            </Grid>
          </div>
        ) : (
          <div style={{ paddingLeft: '10px' }}>
            <Grid container alignItems={'center'}>
              {/* <Avatar alt="Remy Sharp" src="https://material-ui.com/static/images/avatar/1.jpg" /> */}
              <div style={{ /*marginLeft: '10px',*/ fontWeight: 'bold' }}>
                {!this.props.chatData.usernameEn || this.props.chatData.usernameEn === '' || this.props.chatData.usernameEn === 'undefined'
                  ? this.props.chatData.username
                  : this.props.chatData.usernameEn}
              </div>
            </Grid>
            <Grid
              container
              direction={'row'}
              justify={'flex-start'}
              style={
                {
                  /*paddingLeft: '40px'*/
                }
              }
              alignItems={'flex-end'}
            >
              <Paper
                style={{
                  padding: '10px 15px',
                  backgroundColor: '#FFFFFF',
                  maxWidth: '80%',
                  wordBreak: 'break-word',
                  wordWrap: 'break-word',
                  whiteSpace: 'pre-line',
                  // fontSize: '3rem',
                  fontSize: '9rem',
                }}
              >
                {this.props.chatData.data}
              </Paper>
              <div style={{ fontSize: '0.8rem', paddingLeft: '10px' }}>{convertT(this.props.chatData.createdAt)}</div>
            </Grid>
          </div>
        )}
      </div>
    );
  }
}

export default ChatItem;
